import type { IDimensionDefinition } from '@feathr/blackbox';
import { ValidDimensions, ValidFacebookDimensions } from '@feathr/blackbox';

/** Dimension keys shown in the "Most popular" section for display ads. */
export const displayMostPopularKeys = ['300x250', '728x90', '160x600', '300x600'];

/** Dimension keys shown in the "Most popular" section for Meta creatives. */
export const metaMostPopularKeys = ['1080x1080', '1080x1350', '1080x1920', '1920x1080'];

/** Display dimensions not in the "Most popular" list. */
export const displayRemainingDimensions: IDimensionDefinition[] = Object.entries(ValidDimensions)
  .filter(([key]) => !displayMostPopularKeys.includes(key))
  .map(([, dimension]) => dimension);

/** Meta dimension keys not in the "Most popular" list. */
export const metaRemainingKeys: string[] = Object.keys(ValidFacebookDimensions).filter(
  (key) => !metaMostPopularKeys.includes(key),
);

/** Whether the Meta section has dimensions beyond the most popular ones. */
export const hasMetaRemainingDimensions: boolean = metaRemainingKeys.length > 0;
